"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/sliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Improved Mobility" | "Injury Rehabilitation" | "Muscle Strengthening" | "Personalized Treatment Plans" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
};

type SliderSectionServicesSlides2Item = {
    key: Key | null | undefined;
    /** Detected variants: "Preventive Healthcare" | "Personalized Treatment Plans" | "Injury Rehabilitation" | "Improved Mobility" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "title" */
    h30ClassName?: string;
};
export type HomeEighteenSliderSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    sliderSectionServicesSlides2DivH30H3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    /** Default: "right" */
    sectionDiv1DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv1DivDataSpeed?: string;
    sliderSectionServicesSlides: SliderSectionServicesSlidesItem[];
    sliderSectionServicesSlides2: SliderSectionServicesSlides2Item[];
    sliderSectionServicesSlidesItemWrapper?: (item: SliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    sliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Visible?: boolean;
    sliderSectionServicesSlidesH3Renderer?: (item: SliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    sliderSectionServicesSlides2ItemWrapper?: (item: SliderSectionServicesSlides2Item, content: ReactNode) => ReactNode;
    sliderSectionServicesSlides2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlides2H3Visible?: boolean;
    sliderSectionServicesSlides2H3Renderer?: (item: SliderSectionServicesSlides2Item, defaultNode: ReactNode) => ReactNode;
    sliderSectionServicesSlides2H3Props?: Partial<ComponentProps<"h3">> | ((item: SliderSectionServicesSlides2Item) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenSliderSectionGenerated: FC<HomeEighteenSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    sectionDiv1DivDataDirection = "right",
    sectionDiv1DivDataSpeed = "slow",
    divH30H3Props,
    sliderSectionServicesSlides2DivH30H3Props,
    sliderSectionServicesSlides,
    sliderSectionServicesSlides2,
    sliderSectionServicesSlidesItemWrapper,
    sliderSectionServicesSlidesRenderer,
    sliderSectionServicesSlidesH3Visible,
    sliderSectionServicesSlidesH3Renderer,
    sliderSectionServicesSlidesH3Props,
    sliderSectionServicesSlides2ItemWrapper,
    sliderSectionServicesSlides2Renderer,
    sliderSectionServicesSlides2H3Visible,
    sliderSectionServicesSlides2H3Renderer,
    sliderSectionServicesSlides2H3Props,
}) => {
    return (
        <section className="slider-section pb-0 wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-eighteen bg-primary d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        sliderSectionServicesSlides,
                        (item: SliderSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(sliderSectionServicesSlidesH3Visible, sliderSectionServicesSlidesH3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "title"} {...(typeof sliderSectionServicesSlidesH3Props === "function" ? sliderSectionServicesSlidesH3Props(item) : (sliderSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        sliderSectionServicesSlidesItemWrapper,
                        sliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
            <div className="horizontal-slide slide-eighteen bg-secondary d-flex" data-direction={sectionDiv1DivDataDirection} data-speed={sectionDiv1DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        sliderSectionServicesSlides2,
                        (item: SliderSectionServicesSlides2Item) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(sliderSectionServicesSlides2H3Visible, sliderSectionServicesSlides2H3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "title"} {...(typeof sliderSectionServicesSlides2H3Props === "function" ? sliderSectionServicesSlides2H3Props(item) : (sliderSectionServicesSlides2H3Props ?? {}))} {...(typeof sliderSectionServicesSlides2DivH30H3Props === "function" ? sliderSectionServicesSlides2DivH30H3Props(item) : (sliderSectionServicesSlides2DivH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        sliderSectionServicesSlides2ItemWrapper,
                        sliderSectionServicesSlides2Renderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeEighteenSliderSectionGenerated;
